"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerOverlay = void 0;
const Spinner_1 = require("@amzn/atoz-web/Spinner");
const Theme_1 = require("@amzn/atoz-web/Theme");
const View_1 = require("@amzn/atoz-web/View");
const react_1 = __importDefault(require("react"));
const constants_1 = require("../../components/SpinnerOverlay/constants");
const SpinnerOverlay = ({ isLoading, children }) => {
    return (react_1.default.createElement(Wrapper, { width: '100%' },
        isLoading && (react_1.default.createElement(SpinnerContainer, { alignItems: "center", justifyContent: "center" },
            react_1.default.createElement(Spinner_1.Spinner, { dataTestId: constants_1.SPINNER_OVERLAY_TEST_ID, size: Spinner_1.SpinnerSize.Medium }))),
        children));
};
exports.SpinnerOverlay = SpinnerOverlay;
const Wrapper = (0, Theme_1.styledWithTheme)(View_1.View)(() => `
        position: relative;
    `);
const SpinnerContainer = (0, Theme_1.styledWithTheme)(View_1.View)(({ theme }) => `
        display: flex;
        width: 100%;
        height: 100%;
        position: absolute;
        background: ${theme.selectors.color('neutral0-alpha50')};
        z-index: ${theme.selectors.zIndex('alert')};
    `);
